import Vue from 'vue';

Vue.filter('amazon_url', function (asin) {
  return asin ? `https://www.amazon.com/dp/${asin}` : '#';
});

Vue.filter('ceil', function (value, exp = 1) {
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math.ceil(value);
  }

  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }

  value = +value;
  exp = +exp;

  value = value.toString().split('e');
  value = Math.ceil(+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Обратный сдвиг
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
});
